/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrmProjectNoteData } from './CrmProjectNoteData';
import {
    CrmProjectNoteDataFromJSON,
    CrmProjectNoteDataFromJSONTyped,
    CrmProjectNoteDataToJSON,
    CrmProjectNoteDataToJSONTyped,
} from './CrmProjectNoteData';

/**
 * 
 * @export
 * @interface CrmProjectNotePageData
 */
export interface CrmProjectNotePageData {
    /**
     * 
     * @type {Array<CrmProjectNoteData>}
     * @memberof CrmProjectNotePageData
     */
    items?: Array<CrmProjectNoteData>;
    /**
     * 
     * @type {number}
     * @memberof CrmProjectNotePageData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CrmProjectNotePageData
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof CrmProjectNotePageData
     */
    total?: number;
}

/**
 * Check if a given object implements the CrmProjectNotePageData interface.
 */
export function instanceOfCrmProjectNotePageData(value: object): value is CrmProjectNotePageData {
    return true;
}

export function CrmProjectNotePageDataFromJSON(json: any): CrmProjectNotePageData {
    return CrmProjectNotePageDataFromJSONTyped(json, false);
}

export function CrmProjectNotePageDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectNotePageData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(CrmProjectNoteDataFromJSON)),
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'total': json['total'] == null ? undefined : json['total'],
    };
}

export function CrmProjectNotePageDataToJSON(json: any): CrmProjectNotePageData {
    return CrmProjectNotePageDataToJSONTyped(json, false);
}

export function CrmProjectNotePageDataToJSONTyped(value?: CrmProjectNotePageData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(CrmProjectNoteDataToJSON)),
        'page': value['page'],
        'pageSize': value['pageSize'],
        'total': value['total'],
    };
}

